import { H4 } from "@/components/standard/BFText"
import { Horizontal } from "@/components/standard/BFLayout"
import { PlayStoreDownloadButton } from "@/components/buttons/PlayStoreDownloadButton"
import { AppleStoreDownloadButton } from "@/components/buttons/AppleStoreDownloadButton"
import { View } from "react-native"
import { preQualLandingPageIntentClick } from "@/analytics/events/preQual"
import useDeviceAttributes from "@/hooks/useDeviceAttributes"

export const DownloadAppBar = () => {
  const { isLargeScreen } = useDeviceAttributes()

  if (isLargeScreen) {
    return null
  }

  return (
    <Horizontal
      className={"px-5 h-[40px] gap-0 bg-teal items-center justify-center"}
    >
      <H4 className={"text-midnight-blue flex-1"}>Download the App</H4>

      <View className={"flex-1 mt-[-16px] mr-[-20px]"}>
        <PlayStoreDownloadButton
          width={100}
          height={30}
          onPress={() => {
            preQualLandingPageIntentClick({
              intent: "Download",
              id: "app-download",
              title: "Download PlayStore",
            })
          }}
        />
      </View>
      <AppleStoreDownloadButton
        width={120}
        height={30}
        onPress={() => {
          preQualLandingPageIntentClick({
            intent: "Download",
            id: "app-download",
            title: "Download AppStore",
          })
        }}
      />
    </Horizontal>
  )
}
